export const EnumResultadoAR = () => {
  return [
    { tipo: 'APROVADO', descricao: 'Aprovado' },
    { tipo: 'REPROVADO', descricao: 'Reprovado' },
  ];
};
